import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Home from '@/views/Home.vue'
import Concept from '@/views/Concept.vue'
import Advantages from '@/views/Advantages.vue'
import Contact from '@/views/Contact.vue'
import FAQ from '@/views/FAQ.vue'
import Shop from '@/views/Shop.vue'
import Checkout from '@/views/Checkout.vue'
import AppBar from '@/components/AppBar.vue'
import Payment from '@/views/Payment.vue'
import PaymentSuccess from '@/views/PaymentSuccess.vue'
import { LayoutStyle } from '@/types'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/fr/home'
  }, 
  {
    path: '/:lang/home',
    name: 'HomeWithLanguage',
    components: {
      default: Home,
      appBar: AppBar
    },
    props: {
      default: false,
      appBar: () => ({ specialLayout: LayoutStyle.GreenCircleGradient })
    }
  },
  {
    path: '/:lang/order/:step?',
    name: 'Shop',
    components: {
      default: Shop,
      appBar: AppBar
    },
    props: {
      default: (route) => {
        const step = Number.parseInt(route.params.step, 10)
        if (Number.isNaN(step)) {
          return 0
        }
        return { step }
      },
      appBar: () => ({ specialLayout: LayoutStyle.TwoColorsGreenAndWhite })
    }
  },
  {
    path: '/:lang/checkout',
    name: 'Checkout',
    components: {
      default: Checkout,
      appBar: AppBar
    },
    props: {
      default: false,
      appBar: () => ({ specialLayout: LayoutStyle.GreenCircleGradient })
    }
  },
  {
    path: '/:lang/concept',
    name: 'Concept',
    components: {
      default: Concept,
      appBar: AppBar
    },
    props: {
      default: false,
      appBar: () => ({ specialLayout: LayoutStyle.GreenCircleGradient })
    }
  },
  {
    path: '/:lang/advantages',
    name: 'Advantages',
    components: {
      default: Advantages,
      appBar: AppBar
    },
    props: {
      default: false,
      appBar: () => ({ specialLayout: LayoutStyle.GreenCircleGradient })
    }
  },
  {
    path: '/:lang/faq',
    name: 'FAQ',
    components: {
      default: FAQ,
      appBar: AppBar
    },
    props: {
      default: false,
      appBar: () => ({ specialLayout: LayoutStyle.GreenCircleGradient })
    }
  },
  {
    path: '/:lang/contact',
    name: 'Contact',
    components: {
      default: Contact,
      appBar: AppBar
    },
    props: {
      default: false,
      appBar: () => ({ specialLayout: LayoutStyle.GreenCircleGradient })
    }
  },
  {
    path: '/:lang/thanks',
    name: 'Thanks',
    components: {
      default: PaymentSuccess,
      appBar: AppBar
    },
    props: {
      default: true,
      appBar: () => ({ specialLayout: LayoutStyle.GreenCircleGradient })
    }
  },
  {
    path: '/:lang/payment',
    name: 'Payment',
    components: {
      default: Payment,
      appBar: AppBar
    },
    props: {
      default: true,
      appBar: () => ({ specialLayout: LayoutStyle.GreenCircleGradient })
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }  
})

export default router
